export const auditControl = {
  routes: [
    {
      path: "/audit-control/compliance",
      component: () => import("../organization-control-view"),
      props: { allowedClass: "COMPLIANCE_MANAGEMENT", lockedClass: true },
    },
    {
      path: "/audit-control/control",
      component: () => import("../organization-control-view"),
      props: { allowedClass: "CONTROL_ACTIVITY", lockedClass: true },
    },
    {
      path: "/audit-control/audit",
      component: () => import("../organization-control-view"),
      props: { allowedClass: "AUDIT_ACTIVITY", lockedClass: true },
    },
    {
      path: "/audit-control/dashboard",
      // component: () => import("../organization-control-view"),
      props: { allowedClass: "CONTROL_ACTIVITY", lockedClass: true }, // Defaulting dashboard to control activity for now if enabled later
    },
    // New Control creation routes specific to class
    {
      path: "/audit-control/compliance/create",
      component: () => import("../organization-control-detail"),
      props: { allowedClass: "COMPLIANCE_MANAGEMENT", lockedClass: true },
    },
    {
      path: "/audit-control/control/create",
      component: () => import("../organization-control-detail"),
      props: { allowedClass: "CONTROL_ACTIVITY", lockedClass: true },
    },
    {
      path: "/audit-control/audit/create",
      component: () => import("../organization-control-detail"),
      props: { allowedClass: "AUDIT_ACTIVITY", lockedClass: true },
    },
    // Detail routes
    {
      path: "/audit-control/compliance/detail/:id",
      component: () => import("../organization-control-detail"),
      props: { allowedClass: "COMPLIANCE_MANAGEMENT", lockedClass: true },
    },
    {
      path: "/audit-control/control/detail/:id",
      component: () => import("../organization-control-detail"),
      props: { allowedClass: "CONTROL_ACTIVITY", lockedClass: true },
    },
    {
      path: "/audit-control/audit/detail/:id",
      component: () => import("../organization-control-detail"),
      props: { allowedClass: "AUDIT_ACTIVITY", lockedClass: true },
    },
    {
      path: "/audit-control/control/create",
      component: () => import("../organization-control-detail"),
    },
    {
      path: "/audit-control/control/detail/:id",
      component: () => import("../organization-control-detail"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/library/control-type",
      component: () => import("../../library/management-library-control-type-view"),
    },
    {
      path: "/management/library/control-category",
      component: () => import("../../library/management-library-control-category-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/library/control-type",
      component: () => import("../../library/workspace-library-control-type-view"),
    },
    {
      path: "/workspace/library/control-category",
      component: () => import("../../library/workspace-library-control-category-view"),
    },
  ],
};
